import axios from "axios";
import interceptors from "@/shared/api/interceptors";

const apiClientPdf = axios.create({
  baseURL: window.__CONFIG__.VUE_APP_BASE_DOMAIN + "/pdf",
  withCredentials: true,
});

interceptors(apiClientPdf);

export default apiClientPdf;
